import { render } from "./StudentsByGpaGender.vue?vue&type=template&id=49fedea6"
import script from "./StudentsByGpaGender.vue?vue&type=script&lang=js"
export * from "./StudentsByGpaGender.vue?vue&type=script&lang=js"
script.render = render

export default script